/** Preview must use the same caller context as the final quotation save. */
export const buildQuotationPromoRequest = (request: Record<string, any>, erp: boolean) => ({
	...request,
	erp
});

/** An empty/filtered response is not a valid zero-discount token promo. */
export const resolveQuotationPromo = (response: any, requestedCode: string) => {
	const rows = Array.isArray(response) ? response
		: Array.isArray(response?.data) ? response.data
			: Array.isArray(response?.amounts) ? response.amounts
				: response?.promoCode || response?.promo_code ? [response] : [];
	const code = requestedCode.trim().toUpperCase();
	const row = rows.find((candidate: any) =>
		String(candidate?.promoCode ?? candidate?.promo_code ?? '').trim().toUpperCase() === code);
	const rawAmount = row?.discountAmt ?? row?.discount_amt;
	if (rawAmount === undefined || rawAmount === null || rawAmount === '') return null;
	const discountAmt = Number(rawAmount);
	if (!Number.isFinite(discountAmt) || discountAmt < 0) return null;
	return { ...row, promoCode: code, discountAmt };
};
